import axios from 'axios';
import router from '../router/index';
import store from '../vuex/store';
// const apiurl = "http://192.168.2.46:4564"
const apiurl = 'https://api.pdfshuwu.com'
// 登录请求方法
const loginreq = (method, url, params) => {
    return axios({
        method: method,
        url: apiurl + url,
        data: params,
    }).then(res => res.data);
};
// 通用公用方法
const req = (method, url, data, params) => {
    return axios({
        method: method,
        url: apiurl + url,
        headers: {
            'Authorization': localStorage.getItem('logintoken')
        },
        data: data,
        params: params
    }).then(res => {
        if (res.data.code == 414) {
            store.commit('logout', 'false')
            router.push({ path: '/login' })
        }
        return res.data;
    }
    )
};

export {
    loginreq,
    req
}


// WEBPACK FOOTER //
// ./src/api/axiosFun.js